import { ITokenAccessor } from 'libs/grpckit/src/AuthenticationInterceptor';
import { Lifecycle, Module } from 'libs/uikit/ioc';
import { IAuthenticationStore } from './Abstractions/IAuthenticationStore';
import { IUserDirector } from './Abstractions/IUserDirector';
import { AuthenticationStore } from './AuthenticationStore';
import { UserDirector } from './UserDirector';

export const CoreModule = new Module({
  providers: [
    {
      provide: IAuthenticationStore,
      useClass: AuthenticationStore,
      lifecycle: Lifecycle.Singleton,
    },
    {
      provide: ITokenAccessor,
      useFactory: (injector) => {
        return injector.resolve(IAuthenticationStore);
      },
    },
    {
      provide: IUserDirector,
      useClass: UserDirector,
    },
  ],
});
